import BackgroundImage from "./background-image"
import CheckoutUi from "./checkout-ui"
import ClickAndCollect from "./click-and-collect"
import Datepicker from "./datepicker"
import MegaMenu from "./megamenu"
import Nav from "./nav"
import QuickNav from "./quick-nav"
import ScrollToBottom from "./scroll-to-bottom"
import { doQuantityValidation, isInt } from './variations_array_quantity_validation';
import WoocommerceCheckoutDiscount from "./woocommerce-checkout-discount"
import ToggleData from "./toggle-data"

import ProductGlobalAddToCart from "./product_global_add_to_cart"
import ProductMultiselect from "./product_multiselect"
import ProductVariationPreview from "./product_variation_preview"
import VariationAddToCart from "./variation_add_to_cart"
import Slider from "./slider"
import Search from "./search"

document.addEventListener("DOMContentLoaded", function () {

  window.doQuantityValidation = doQuantityValidation
  window.isInt = isInt

  Datepicker(jQuery)
  CheckoutUi(jQuery)
  ClickAndCollect(jQuery)

  MegaMenu(jQuery)
  Nav(jQuery)
  BackgroundImage(jQuery)
  QuickNav(jQuery)
  ScrollToBottom(jQuery)
  WoocommerceCheckoutDiscount(jQuery)
  ToggleData(jQuery)

  ProductGlobalAddToCart(jQuery)
  ProductMultiselect(jQuery)
  ProductVariationPreview(jQuery)
  VariationAddToCart(jQuery)

  Slider(jQuery)
  Search(jQuery)

})
